import { lazy } from "react";
const ContractManagement = lazy(
  () => import("@/pages/contractManagement/page"),
);

const contractRoute = [
  {
    path: "/contractManagement",
    name: "合同管理",
    component: ContractManagement,
  },
];
export default contractRoute;
